import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {WidgetDirective} from '@components/widget/widget.directive';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {TrackingService} from '@services/tracking.service';
import {environment} from '~/environments/environment';
import {AlertService} from '@services/alert.service';
import {TOO_MANY_REQUESTS} from '~/app/shared/helpers/error.interceptor';

@Component({
    selector: 'app-config-project-url',
    templateUrl: './config-project-url.component.html',
    styleUrls: ['./config-project-url.component.scss']
})
export class ConfigProjectUrlComponent implements OnInit {
    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;
    url = '';
    loading = false;

    constructor(
        public dialog: MatDialog,
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        private adService: AdService,
        private alertService: AlertService,
        public authenticationService: AuthenticationService,
        public cityService: CityService,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            if (params.url  != undefined && params.url != '') {
                this.url = params.url;
                this.saveSimulation(false);
            }
        });
    }

    saveSimulation(retry) {
        this.loading = true;
        this.adService.openURL(this.url).subscribe(response => {
            if (response.status == 202) {
                if (retry == true) {
                    setTimeout(function() {
                        this.saveSimulation(false);
                    }.bind(this), 20000);
                } else {
                    this.loading = false;
                    this.alertService.error('Impossible de récupérer l\'annonce, merci de réessayer dans quelques minutes.');
                }
            } else {
                this.loading = false;
                var favorite = {...response.body!};
                favorite.notary_price = null; // To calc them
                favorite = this.adService.fillUSerInfo(favorite);
                favorite = this.adService.updateValues(favorite);
                favorite.pictures_string = favorite.pictures.join(';');
                this.http.put(environment.apiUrl + 'app/favorite/' + favorite.id, favorite).subscribe(result => {
                    this.router.navigate(['/app/annonces', favorite.id, 'annonce']);
                }, error => {
                    if (error != 'token_outdate') {
                        this.alertService.error('Une erreur est survenue lors de l\'enregistrement.');
                    }
                });
            }
        }, error => {
            this.loading = false;
            if (error == 'Not Acceptable') {
                this.alertService.error("Ce site n'est pas compatible avec LyBox, utilisez le menu \"Nouveau projet\" pour rentrer les informations.");
            } else if (error == TOO_MANY_REQUESTS) {
                this.alertService.error('Vous avez importé beaucoup d\'annonces, réessayez dans une heure.');
            } else if (error != 'token_outdate') {
                this.alertService.error('Annonce introuvable');
            }
        });
    }
}
